import request from '@/utils/request'
import URL from './urlTranslator'

export function getSopEmailLog(data) {
  return request({
    url: `${URL.sys.sopEmailLog}`,
    method: 'put',
    data
  })
}

export function getPushNodeTree() {
  return request({
    url: `${URL.sys.pushNodeTree}`,
    method: 'get'
  })
}
